import Request from '@/common/copyright/request';

// 全部证据的搜索列表
export const allFileSearchApi = (data) => Request.post('/pan/api/allFile/search', data, {
    'allowCance': true,
}); 

// 全部证据下载证据和证书
export const allEvidenceDownNewApi = (params,) => Request.post('/pan/api/allFile/drama/download', params, {
    network400: 'custom400'
});